export default "__VITE_ASSET__EeP2BY55__"